var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContact1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 754,
    height: 535,
    viewBox: "0 0 754 535",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3070_197)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 754,
    height: 535,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3070_197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M582.678 21.6572H68.8307C58.1719 21.6572 49.5312 33.8976 49.5312 48.9969V506.937C49.5312 522.036 58.1719 534.277 68.8307 534.277H582.678C593.337 534.277 601.978 522.036 601.978 506.937V48.9969C601.978 33.8976 593.337 21.6572 582.678 21.6572Z",
    fill: "#FFE7C8"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 754,
    height: 535,
    rx: 50.0856,
    fill: "#FFE7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.35 75H284.495C270.414 75 259 86.4143 259 100.495V437.064C259 451.144 270.414 462.558 284.495 462.558H469.35C483.431 462.558 494.845 451.144 494.845 437.064V100.495C494.845 86.4143 483.431 75 469.35 75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.301 400.734H285.544C283.759 400.729 282.048 400.016 280.786 398.753C279.525 397.49 278.814 395.779 278.811 393.993V124.451C278.814 122.665 279.526 120.952 280.789 119.689C282.052 118.425 283.765 117.714 285.551 117.71H468.308C470.094 117.716 471.804 118.428 473.066 119.691C474.328 120.954 475.038 122.666 475.042 124.451V393.993C475.096 394.892 474.958 395.792 474.638 396.634C474.318 397.476 473.823 398.24 473.186 398.876C472.549 399.513 471.784 400.007 470.942 400.326C470.1 400.645 469.2 400.789 468.301 400.734Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.571 172.551C362.815 172.57 356.341 175.261 351.564 180.039C346.787 184.816 344.095 191.29 344.076 198.046V301.943C344.071 302.319 344.164 302.69 344.347 303.019C344.53 303.348 344.796 303.623 345.119 303.817C345.442 304.011 345.81 304.116 346.186 304.123C346.562 304.129 346.934 304.037 347.263 303.855L379.131 275.811C379.634 275.327 380.238 274.962 380.899 274.741C381.561 274.521 382.263 274.451 382.956 274.536H559.505C566.261 274.518 572.735 271.826 577.512 267.049C582.289 262.272 584.981 255.798 584.999 249.042V198.053C584.981 191.297 582.289 184.823 577.512 180.046C572.735 175.268 566.261 172.576 559.505 172.558L369.571 172.551Z",
    fill: "#FFF5C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.035 293.616V393.993C475.089 394.891 474.951 395.791 474.632 396.632C474.312 397.473 473.818 398.237 473.182 398.874C472.545 399.51 471.781 400.004 470.94 400.324C470.099 400.643 469.199 400.781 468.301 400.727H285.544C283.76 400.722 282.051 400.01 280.789 398.749C279.527 397.487 278.816 395.777 278.811 393.993V124.451C278.814 122.665 279.526 120.952 280.789 119.689C282.052 118.425 283.765 117.714 285.551 117.71H468.308C470.094 117.716 471.804 118.428 473.066 119.691C474.328 120.954 475.038 122.666 475.042 124.451V151.484",
    stroke: "#2F2E41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.92 443.692C384.362 443.692 390.395 437.659 390.395 430.217C390.395 422.775 384.362 416.742 376.92 416.742C369.478 416.742 363.445 422.775 363.445 430.217C363.445 437.659 369.478 443.692 376.92 443.692Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.229 97.5017H410.616M494.845 293.615V437.064C494.827 443.819 492.135 450.293 487.358 455.071C482.58 459.848 476.106 462.54 469.35 462.558H284.495C277.739 462.54 271.265 459.848 266.487 455.071C261.71 450.293 259.018 443.819 259 437.064V100.495C259.018 93.7386 261.71 87.2646 266.487 82.4874C271.265 77.7102 277.739 75.0183 284.495 75H469.35C476.106 75.0183 482.58 77.7102 487.358 82.4874C492.135 87.2646 494.827 93.7386 494.845 100.495V151.484",
    stroke: "#2F2E41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.571 172.551C362.815 172.57 356.341 175.261 351.564 180.039C346.787 184.816 344.095 191.29 344.076 198.046V301.943C344.071 302.319 344.164 302.69 344.347 303.019C344.53 303.348 344.796 303.623 345.119 303.817C345.442 304.011 345.81 304.116 346.186 304.123C346.562 304.129 346.934 304.037 347.263 303.855L379.131 275.811C379.634 275.327 380.238 274.962 380.899 274.741C381.561 274.521 382.263 274.451 382.956 274.536H559.505C566.261 274.518 572.735 271.826 577.512 267.049C582.289 262.272 584.981 255.798 584.999 249.042V198.053C584.981 191.297 582.289 184.823 577.512 180.046C572.735 175.268 566.261 172.576 559.505 172.558L369.571 172.551Z",
    stroke: "#2F2E41",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3070_197",
    x: -138.29,
    y: -166.164,
    width: 969.827,
    height: 930,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 20.869,
    dy: 20.869
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 104.345
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.741667 0 0 0 0 0.741667 0 0 0 0 0.741667 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3070_197"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3070_197",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3070_197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 754,
    height: 535,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact1);
export default __webpack_public_path__ + "static/media/contact1.a79ea0ba54fd290a5acd0b3fcd513183.svg";
export { ForwardRef as ReactComponent };